function applyVisibility(immediate = false) {
  $('[data-visibility]').each(function (i, element) {
    const $element = $(element);
    const type = $element.attr('data-visibility');
    const field = $element.attr('data-visibility-field');
    const value = $element.attr('data-visibility-value');
    const data = $element.attr('data-visibility-data');
    const $field = $(field);

    let visible = true;
    if (type == 'checked') {
      visible = $field.prop('checked');
    } else if (type == 'value') {
      if ($field.attr('type') == 'radio') {
        visible = $(`${field}:checked`).val() == value;
      } else {
        visible = $field.val() == value;
      }
    } else if (type == 'data') {
      if ($field.prop('tagName').toLowerCase() == 'select') {
        visible = $field.find('option:selected').data(data) == value;
      } else if ($field.attr('type') == 'radio') {
        visible = $(`${field}:checked`).data(data) == value;
      } else {
        visible = $field.data(data) == value;
      }
    }
    if ($element.attr('data-visibility-invert') == 'true') {
      visible = !visible;
    }
    if (immediate) {
      $element.css('display', visible ? '' : 'none');
    } else {
      if (visible) {
        $element.fadeIn();
      } else {
        $element.hide();
      }
    }
  });
}

if ($) {
  $(document.body).ready(() => {
    applyVisibility(true);
    $('[data-toggle="visibility"]').on("change", event => applyVisibility());
  });
}